import { useEffect, useState } from "react";
import {
    CartesianGrid,
    Legend,
    Line,
    LineChart,
    ReferenceLine,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { CustomLabel, CustomLegend, CustomTooltip, defaultGraphKeys } from "./CustomGrpahCommonComponents";
import { Theme } from "../../Theme";

function CustomLineGraphChart({ data = [], keys = defaultGraphKeys, hasLegend = true, hasBarLabel = false }) {
    const [activeInfo, setActiveInfo] = useState(null);
    const [tooltipX, setTooltipX] = useState(null);
    const CHART_HEIGHT = 314;
    const MARGIN_TOP = 20;
    const MARGIN_BOTTOM = 5;

    const drawableHeight = CHART_HEIGHT - MARGIN_TOP - MARGIN_BOTTOM;
    const tooltipY = MARGIN_TOP + drawableHeight / 2 - 100;

    const handleMouseMove = (e) => {
        if (e && e.activeLabel && e.activeCoordinate) {
            setActiveInfo({
                label: e.activeLabel,
                x: e.activeCoordinate.x,
            });
        }
    };

    const handleMouseLeave = () => {
        setActiveInfo(null);
    };

    // Info: 왠진 모르겠지만 해당 함수를 제거하면 UI가 깨집니다... 호출하진 않음.
    const CustomCursor = (props) => {
        console.log(props);
        const { x, width, payloadIndex } = props;

        console.log({ payloadIndex });
        const centerX = x + width / 2;

        useEffect(() => {
            const TOOLTIP_WIDTH = 320;
            const X_OFFSET = 20;
            let finalX;

            if (payloadIndex <= 3) {
                // 첫 번째 항목은 오른쪽에 표시
                finalX = activeInfo.x + X_OFFSET;
            } else {
                // 두 번째 항목부터는 왼쪽에 표시
                finalX = activeInfo.x - TOOLTIP_WIDTH - X_OFFSET;
            }

            setTooltipX(finalX);
        }, [centerX, payloadIndex]);
    };

    return (
        <ResponsiveContainer width="100%" height={CHART_HEIGHT}>
            <LineChart
                data={data}
                margin={{
                    top: MARGIN_TOP,
                    right: 5,
                    left: -16,
                    bottom: MARGIN_BOTTOM,
                }}
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            >
                {/* 눈금선 (Y축 기준) */}
                <CartesianGrid vertical={false} stroke={Theme.color.gray150} />

                {/* X축: dataKey="name"은 data 배열 객체의 name 키를 사용합니다. */}
                <XAxis
                    dataKey="name"
                    tickLine={false}
                    axisLine={false}
                    tick={{ fontSize: 12, fill: Theme.color.gray400 }}
                    padding={{ left: 60, right: 60 }}
                />

                {/* Y축: 도메인(범위) */}
                <YAxis
                    domain={[0, (dataMax) => Math.ceil(dataMax / 100) * 100]}
                    tickLine={false}
                    axisLine={false}
                    tickCount={6}
                    allowDecimals={false}
                    tick={{ fontSize: 11, fill: Theme.color.gray400 }}
                />

                {activeInfo && (
                    <ReferenceLine
                        x={activeInfo.label}
                        stroke={Theme.color.indigo500_01}
                        strokeDasharray="3 3"
                        strokeWidth={1}
                    />
                )}

                {/* 마우스를 올렸을 때 뜨는 툴팁 */}
                <Tooltip
                    content={<CustomTooltip />}
                    cursor={false}
                    position={{ x: tooltipX, y: tooltipY }}
                    isAnimationActive={false}
                />

                {/* 하단의 범례 (Legend) */}
                {hasLegend && <Legend content={<CustomLegend />} />}

                {/* 각 데이터 시리즈에 대한 라인 그래프 */}
                {keys.map((key, index) => (
                    <Line
                        dataKey={key.name}
                        stroke={key.color}
                        strokeWidth={2}
                        dot={{ r: 2, fill: Theme.color.indigo800 }}
                        label={hasBarLabel ? <CustomLabel /> : null}
                        animationDuration={0}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    );
}

export default CustomLineGraphChart;
